import { submitLogoutForm } from '@rover/rsdk/src/modules/Network/submitLogoutForm';
import { clear as clearLocalStorage } from '@rover/utilities/localStorage';
import { clear as clearSessionStorage } from '@rover/utilities/sessionStorage';

export type LogoutConfig = {
  nextLocation: string;
  ref?: string;
  beforeNavCallback?: () => void;
};
export default async function logout({
  nextLocation,
  ref,
  beforeNavCallback,
}: LogoutConfig): Promise<void> {
  clearLocalStorage();
  clearSessionStorage();
  beforeNavCallback && beforeNavCallback();
  submitLogoutForm(nextLocation, ref);
}
